import { NewClauseChecklistDialog } from "@/components/admin/dialogs/clause-checklists/NewClauseChecklistDialog";
import { ActionButton } from "@/components/shared/buttons/ActionButton";
import { useDialogs } from "@toolpad/core";
import { Plus } from "lucide-react";

/**
 * Button to add a new clause checklist.
 */
export const AddNewClauseChecklistButton = () => {
    const dialogs = useDialogs();

    const handleClick = async () => {
        await dialogs.open(NewClauseChecklistDialog, {});
    };

    return (
        <ActionButton startIcon={<Plus size={16} />} onClick={handleClick}>
            Create
        </ActionButton>
    );
};
